import { reactive } from "vue";
import { materialLibrary } from "../../data";
import { AppSettings } from "../../settings";
import { Configuration, Material } from "../../types/type_def";

/**
 * Which material group the material selector shows, for the current configuration.
 *
 * The configuration itself is the legacy ctx.currentConfiguration object, which app.ts changes directly,
 * so it is kept outside Vue's reactivity; `version` is bumped whenever the selector must re-read it.
 */
export const materialSelection = reactive({
    group: "",
    version: 0,
});

let configuration: Configuration | null = null;

export function getSelectionConfiguration(): Configuration | null {
    return configuration;
}

/**
 * Shows the materials of a group for a configuration.
 * A configuration without a material gets the series' first material.
 */
export function showMaterialSelection(config: Configuration, group: string) {
    configuration = config;
    if (config && !config.data["material"] && materialLibrary.materials[0]) {
        config.data["material"] = materialLibrary.materials[0].productNumber;
    }
    materialSelection.group = group;
    materialSelection.version++;
}

/** Re-reads the configuration (e.g. after the material was changed). */
export function refreshMaterialSelection() {
    materialSelection.version++;
}

/** The selected material of the configuration (falls back to the series' first material). */
export function currentMaterial(): Material | undefined {
    const productNumber = configuration?.data["material"];
    return (productNumber && materialLibrary.getMaterialByProductNumber(productNumber)) || materialLibrary.materials[0];
}

export function materialThumbnail(material: Material): string {
    return `${AppSettings.Paths.BaseMaterialsPath}${material.type}/${material.group}/${material.productNumber}_thumb.jpg`;
}
